module.exports = __webpack_public_path__ + "assets/img/copy.c4068438.svg";